import { useCallback, useEffect, useState } from 'react';
import { debounce } from 'underscore';

import { useResizeObserver } from '@core/js/hooks/useResizeObserver';

import { TCheckArrowsAndMaxTransformProps, TCheckArrowsAndMaxTransformReturn } from '../types';

export const useCheckArrowsAndMaxTransform = ({
    containerEl,
    transformAmount,
    scrollContainerEl,
    isScroll
}: TCheckArrowsAndMaxTransformProps): TCheckArrowsAndMaxTransformReturn => {
    const [data, setData] = useState<TCheckArrowsAndMaxTransformReturn>({
        isVisibleLeftArrow: false,
        isVisibleRightArrow: false,
        maxTransformAmount: transformAmount
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handlerCheckArrowsAndTransform = useCallback(debounce(() => {
        if (!containerEl || !scrollContainerEl) {
            return;
        }

        const maxTransformAmount = scrollContainerEl.offsetWidth - containerEl.offsetWidth;
        const isVisibleLeftArrow = transformAmount !== 0;
        const isVisibleRightArrow = scrollContainerEl.offsetWidth > containerEl.offsetWidth
            && maxTransformAmount > transformAmount;

        setData({
            isVisibleLeftArrow,
            isVisibleRightArrow,
            maxTransformAmount: scrollContainerEl.offsetWidth - containerEl.offsetWidth
        });
    }, 300, true), [containerEl, scrollContainerEl, transformAmount, isScroll]);

    const observe = useResizeObserver({
        callback: handlerCheckArrowsAndTransform,
        observeOptions: undefined
    });

    useEffect(() => {
        if (!isScroll || !containerEl || !scrollContainerEl) {
            return;
        }

        observe(containerEl);
        observe(scrollContainerEl);
    }, [observe, isScroll, containerEl, scrollContainerEl]);

    return data;
};
